import React from 'react';
import { MONO } from '../../constants/fonts';

export function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2.5"
         strokeLinecap="round" strokeLinejoin="round"
         style={{ flexShrink: 0 }} aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2.5"
         strokeLinecap="round" strokeLinejoin="round"
         style={{ flexShrink: 0 }} aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export function FeatureRow({ label, included, muted, light }) {
  const textColor = light
    ? (included ? '#2a2a2a' : '#9ca3af')
    : (muted ? '#4a4f66' : (included ? '#b0b4cc' : '#3a3d4a'));
  const iconColor = light
    ? (included ? '#16a34a' : '#d1d5db')
    : (included ? '#4ade80' : '#3a3d4a');
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 10,
      color: textColor,
      fontSize: '0.83rem',
      lineHeight: 1.5,
    }}>
      <span style={{ color: iconColor, marginTop: 2 }}>
        {included ? <CheckIcon /> : <CrossIcon />}
      </span>
      {label}
    </div>
  );
}

export function SectionLabel({ children }) {
  return (
    <p style={{
      fontFamily: MONO,
      fontSize: '0.78rem',
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#9ca3af',
      margin: '0 0 12px',
    }}>{children}</p>
  );
}
